var _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_55535",
    "data-name": "Group 55535",
    xmlns: "http://www.w3.org/2000/svg",
    width: 57.554,
    height: 48.821,
    viewBox: "0 0 57.554 48.821",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_55531",
    "data-name": "Group 55531",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_85344",
    "data-name": "Path 85344",
    d: "M402.945,273.32h-4.451a11.577,11.577,0,0,1,.7,3.98v16.822a4.964,4.964,0,0,1-.286,1.662h7.358a4.991,4.991,0,0,0,4.985-4.985v-9.17A8.318,8.318,0,0,0,402.945,273.32Z",
    transform: "translate(-353.699 -246.962)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85345",
    "data-name": "Path 85345",
    d: "M12.058,277.3a11.578,11.578,0,0,1,.7-3.98H8.308A8.318,8.318,0,0,0,0,281.629V290.8a4.991,4.991,0,0,0,4.985,4.985h7.359a4.962,4.962,0,0,1-.286-1.662Z",
    transform: "translate(0 -246.963)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85346",
    "data-name": "Path 85346",
    d: "M155.313,234.815H145.137a8.318,8.318,0,0,0-8.308,8.308v16.822a1.662,1.662,0,0,0,1.662,1.662h23.469a1.662,1.662,0,0,0,1.662-1.662V243.123A8.318,8.318,0,0,0,155.313,234.815Z",
    transform: "translate(-121.448 -212.786)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85347",
    "data-name": "Path 85347",
    d: "M177.106,38.84a9.99,9.99,0,1,0,9.992,9.992A10,10,0,0,0,177.106,38.84Z",
    transform: "translate(-148.329 -38.84)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85348",
    "data-name": "Path 85348",
    d: "M40.915,121.689a7.469,7.469,0,1,0,7.472,7.472A7.481,7.481,0,0,0,40.915,121.689Z",
    transform: "translate(-29.684 -112.376)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85349",
    "data-name": "Path 85349",
    d: "M353.079,121.689a7.472,7.472,0,1,0,7.472,7.472A7.481,7.481,0,0,0,353.079,121.689Z",
    transform: "translate(-306.757 -112.376)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/group.a255a57c3efc2dac8807dfb7203f5320.svg";
export { ForwardRef as ReactComponent };